const CONTEXT_FIELD_VALIDATORS = {
  subject: (data) => Boolean(data?.subjectId && String(data?.subject || '').trim()),
};

export function getRequiredContextFields(...configs) {
  return [...new Set(configs.flatMap((config) => (
    Array.isArray(config?.requiredContextFields)
      ? config.requiredContextFields
      : []
  )).filter(Boolean))];
}

export function resolveMentionTypeForOffence(offence, mentionTypes) {
  const types = Array.isArray(mentionTypes) ? mentionTypes : [];
  if (offence?.mentionTypeId) {
    const byId = types.find((type) => type.id === offence.mentionTypeId);
    if (byId) return byId;
  }
  if (offence?.mentionType) {
    const byValue = types.find((type) => type.value === offence.mentionType);
    if (byValue) return byValue;
  }
  return types.find((type) => type.isDefault) || null;
}

export function offenceRequiresContext(offence, mentionTypes, field) {
  const mentionType = resolveMentionTypeForOffence(offence, mentionTypes);
  return getRequiredContextFields(offence, mentionType).includes(field);
}

export function selectedOffencesRequireContext(
  selectedOffences,
  offences,
  mentionTypes,
  field,
) {
  const selected = Array.isArray(selectedOffences) ? selectedOffences : [];
  const available = Array.isArray(offences) ? offences : [];

  return selected.some((name) => {
    const offence = available.find((item) => item.name === name);
    return offenceRequiresContext(offence, mentionTypes, field);
  });
}

export function getMissingRequiredContextFields(configs, data) {
  const sources = Array.isArray(configs) ? configs : [configs];
  return getRequiredContextFields(...sources).filter((field) => {
    const validator = CONTEXT_FIELD_VALIDATORS[field];
    return validator ? !validator(data) : !data?.[field];
  });
}

export function assertRequiredMentionContext(configs, data) {
  const missing = getMissingRequiredContextFields(configs, data);
  if (missing.length === 0) return;

  const labels = missing.map((field) => (
    field === 'subject' ? 'Subject' : field
  ));
  throw new Error(`${labels.join(', ')} required for this Mention type`);
}
